import type { JSX } from 'react';

import styled from 'styled-components';

import Spinner from '../CargillLeafSpinner';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
`;

function SplashLoader(): JSX.Element {
  return (
    <Wrapper>
      <Spinner size={64} />
    </Wrapper>
  );
}

export default SplashLoader;
